import { connect } from "react-redux";
import ReturnOrderWindow from "../components/_ReturnOrderWindow";
import * as actions from "../../../_actions/order";
import * as miscActions from "../../../_actions/misc";

const mapStateToProps = ({ OrderReturn, Misc }) => ({
    loading: OrderReturn.fetching.loading,
    err: OrderReturn.fetching.err,
    language: Misc.language.language,
    store: Misc.store.store,
    returnReasons: OrderReturn.Reasons.data || [],
    returnReasonsLoading: OrderReturn.Reasons.fetch.loading,
    returnReasonsLoadingError: OrderReturn.Reasons.fetch.err
});

const mapDispatchToProps = dispatch => ({
    returnOrder: (orderId, returnOrderData, language) => {
        dispatch(actions.returnOrder(orderId, returnOrderData, language));
    },
    getOrder: id => {
        dispatch(actions.get(id));
    },
    getReturnReasons: () => {
        dispatch(miscActions.getReturnReasons());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnOrderWindow);
